import {
  BILLING_CHECKLIST_EVENT_LIST_REQUEST,
  BILLING_CHECKLIST_EVENT_LIST_RECEIVED,
  BILLING_CHECKLIST_EVENT_LIST_ERROR,
  BILLING_CHECKLIST_EVENT_LIST_SET_PAGE,
  BILLING_CHECKLIST_EVENT_LIST_UNLOAD,
  BILLING_CHECKLIST_EVENT_SINGLE_REQUEST,
  BILLING_CHECKLIST_EVENT_SINGLE_RECEIVED,
  BILLING_CHECKLIST_EVENT_SINGLE_ERROR,
  BILLING_CHECKLIST_EVENT_LIST_SET_FILTERS,
  BILLING_CHECKLIST_EVENT_LIST_CLEAR_FILTERS,
  BILLING_CHECKLIST_EVENT_SINGLE_UPDATE_REQUEST,
  BILLING_CHECKLIST_EVENT_SINGLE_UPDATED,
  BILLING_CHECKLIST_EVENT_SINGLE_UNLOAD,
  BILLING_CHECKLIST_EVENT_DELETE_REQUEST,
  BILLING_CHECKLIST_EVENT_DELETED,
} from '../constants';

import { hydraPageCount } from '../../helper/apiUtils';

const reducer = (
  state = {
    billingChecklistEvents: [],
    isFetchingBillingChecklistEvents: false,
    currentPage: 1,
    isUpdatingBillingChecklistEvent: false,
    isFetchingBillingChecklistEvent: false,
    hasLoadedBillingChecklistEvent: false,
    pageCount: null,
    billingChecklistEvent: null,
    filters: {},
  },
  action,
) => {
  switch (action.type) {
    case BILLING_CHECKLIST_EVENT_LIST_UNLOAD:
      return {
        billingChecklistEvents: [],
        isFetchingBillingChecklistEvents: false,
        currentPage: 1,
        pageCount: null,
        filters: {},
      };

    case BILLING_CHECKLIST_EVENT_LIST_REQUEST:
      return {
        ...state,
        isFetchingBillingChecklistEvents: true,
      };

    case BILLING_CHECKLIST_EVENT_LIST_RECEIVED:
      return {
        ...state,
        billingChecklistEvents: action.data['hydra:member'],
        pageCount: hydraPageCount(action.data),
        isFetchingBillingChecklistEvents: false,
      };

    case BILLING_CHECKLIST_EVENT_LIST_ERROR:
      return {
        ...state,
        isFetchingBillingChecklistEvents: false,
      };
    case BILLING_CHECKLIST_EVENT_LIST_SET_PAGE:
      return {
        ...state,
        currentPage: action.page,
      };

    case BILLING_CHECKLIST_EVENT_SINGLE_REQUEST:
      return {
        ...state,
        isFetchingBillingChecklistEvent: true,
      };

    case BILLING_CHECKLIST_EVENT_SINGLE_RECEIVED:
      return {
        ...state,
        billingChecklistEvents: [
          ...state.billingChecklistEvents.map((x) => {
            return action.data.id === x.id ? action.data : x;
          }),
        ],
        hasLoadedBillingChecklistEvent: true,
        billingChecklistEvent: action.data,
        isFetchingBillingChecklistEvent: false,
      };

    case BILLING_CHECKLIST_EVENT_SINGLE_ERROR:
      return {
        ...state,
        error: action.error,
        isFetchingBillingChecklistEvent: false,
      };

    case BILLING_CHECKLIST_EVENT_SINGLE_UNLOAD:
      return {
        ...state,
        billingChecklistEvent: null,
        hasLoadedBillingChecklistEvent: false,
        error: null,
        isFetchingBillingChecklistEvent: false,
        isUpdatingBillingChecklistEvent: false,
      };

    case BILLING_CHECKLIST_EVENT_LIST_SET_FILTERS:
      return {
        ...state,
        filters: action.filters,
      };

    case BILLING_CHECKLIST_EVENT_LIST_CLEAR_FILTERS:
      return {
        ...state,
        filters: {},
      };

    case BILLING_CHECKLIST_EVENT_SINGLE_UPDATE_REQUEST:
      state = {
        ...state,
        isUpdatingBillingChecklistEvent: true,
      };
      return state;

    case BILLING_CHECKLIST_EVENT_SINGLE_UPDATED:
      return {
        ...state,
        billingChecklistEvents: [
          ...state.billingChecklistEvents.map((x) => {
            return action.data.id === x.id ? action.data : x;
          }),
        ],
        billingChecklistEvent: action.data,
        isUpdatingBillingChecklistEvent: false,
      };
    case BILLING_CHECKLIST_EVENT_DELETE_REQUEST:
      return {
        ...state,
        isDeletingBillingChecklistEvent: true,
      };
    case BILLING_CHECKLIST_EVENT_DELETED:
      return {
        ...state,
        isDeletingBillingChecklistEvent: false,
      };

    default:
      return state;
  }
};

export default reducer;
